import { MessageService } from '../service/message.service';
import { ResizedEvent } from 'src/app/shared/resize-event/resized-event';
import { AppComponent } from './../../app.component';
import { Component, Output, EventEmitter, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FilterService } from '../../core/filter/filter.service';
import { Filter } from 'src/app/core/filter/filter';
import { AuthenticationService } from '../authentication/authentication.service';
import { Router } from '@angular/router';
import { MessageHandlerService } from '../utility/message-handler.service';
import { Subscription } from 'rxjs';
import { MessageSubject, MessengerService } from '../service/messenger.service';
import { SettingService } from '../service/setting.service';
import { NoticeService } from '../service/notice.service';
import moment from 'moment';
import { SettingNavService } from '../setting-nav/setting-nav.service';
import { UserService } from '../service/user.service';
import { AnalyticService } from '../service/analytic.service';
import { sortBy } from 'lodash';
import { MemberService } from '../service/member.service';
import { CaseService } from '../service/case.service';
import { ChatService } from '../service/chat.service';
import { SessionStorageService } from 'ngx-webstorage';

@Component({
  standalone: false,
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit, OnDestroy
{
  @Output() public minHeight: number;
  @Output() public collapsedEvent = new EventEmitter<boolean>();

  public menuItems = {
    tasks: {
      items: []
    },
    referralTasks: {
      items: []
    },
    cases: {
      items: []
    },
    programs: {
      items: []
    },
    members: {
      items: []
    },
    events: {
      items: []
    },
    assessments: {
      items: []
    },
    messages: {},
    settings: {},
    dashboards: {
      items: []
    },
    providers: {
      items: []
    },
    analytics: {
      items: []
    }
  };

  public isActive: boolean;
  public collapsed: boolean;
  public accessReports = false;
  public accessMessages = false;
  public accessChats = false;
  public accessCommunityServiceSearch = false;
  public accessAddUpdateCommunityResources = false;
  public showMenu: any = [];
  public unreadMessages = 0;
  public unreadChats = 0;
  public noticeCount = 0;
  public patientLabel = {};
  public filterDialogOpened = false;
  public filterCategory: string;
  public filter: Filter;
  public communityEnabled = false;
  public providerEnabled = false;
  public kno2Enabled = false;
  public displaySettingsMenuCard = false;
  public settingItems: Array<{ titleKey: string; descriptionKey: string; permissions: string[]; route: string }> = [];
  public accessProviders = false;
  public accessAnalytics = false;
  public communityLabel = {};

  /**
   * Authentication status
   */
  private isAuthenticated: boolean;
  private contentResizeEventSubscription: Subscription;
  private messagingSubscription: Subscription;
  private authServiceSubscription: Subscription;

  constructor(
    private filterService: FilterService,
    private messageService: MessageService,
    private chatService: ChatService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private appComponent: AppComponent,
    private messageHandlerService: MessageHandlerService,
    private messengerService: MessengerService,
    private changeDetectorRef: ChangeDetectorRef,
    private settingService: SettingService,
    private settingNavService: SettingNavService,
    private userService: UserService,
    private analyticService: AnalyticService,
    private memberService: MemberService,
    private caseService: CaseService,
    private sessionStorage: SessionStorageService,
    private noticeService: NoticeService)
  {
    this.isAuthenticated = authenticationService.isAuthenticated;
    if (this.isAuthenticated)
    {
      filterService.filterChanged.subscribe({
        next: (filter) =>
        {
          switch (filter.category)
          {
            case 'Program':
              if (!this.menuItems.programs.items.some(f => f.id === filter.id))
              {
                this.menuItems.programs.items.push({ name: filter.name, id: filter.id });
              }
              break;
            case 'Case':
              if (!this.menuItems.cases.items.some(f => f.id === filter.id))
              {
                this.menuItems.cases.items.push({ name: filter.name, id: filter.id });
              }
              break;
            case 'Task':
              if (!this.menuItems.tasks.items.some(f => f.id === filter.id))
              {
                this.menuItems.tasks.items.push({ name: filter.name, id: filter.id });
              }
              break;
            case 'ReferralTask':
              if (!this.menuItems.referralTasks.items.some(f => f.id === filter.id))
              {
                this.menuItems.referralTasks.items.push({ name: filter.name, id: filter.id });
              }
              break;
            case 'Member':
              if (!this.menuItems.members.items.some(f => f.id === filter.id))
              {
                this.menuItems.members.items.push({ name: filter.name, id: filter.id });
              }
              break;
            case 'Event':
              if (!this.menuItems.events.items.some(f => f.id === filter.id))
              {
                this.menuItems.events.items.push({ name: filter.name, id: filter.id });
              }
              break;
            case 'Assessment':
              if (!this.menuItems.assessments.items.some(f => f.id === filter.id))
              {
                this.menuItems.assessments.items.push({ name: filter.name, id: filter.id });
              }
              break;
            case 'Dashboard':
              if (!this.menuItems.dashboards.items.some(f => f.id === filter.id))
              {
                this.menuItems.dashboards.items.push({ name: filter.name, id: filter.id });
              }
              break;
          }
        }
      });
    }

    this.contentResizeEventSubscription = this.appComponent.contentResizeEvent.subscribe({
      next: (event: ResizedEvent) =>
      {
        this.minHeight = event.newHeight;
      }
    });

    this.messagingSubscription = this.messengerService.receiveMessage().subscribe({
      next: (message) =>
      {
        if (message && message.type && message.type === 'wsChatCount')
        {
          const selectedChatId = this.sessionStorage.retrieve('chat-selected-id');
          const responseMessage = JSON.parse(message.data.body);

          // Totalize the unreadCount for each chatId
          let chatCount = 0;
          responseMessage.forEach((chatCountData: any) =>
          {
            // If the chat is selected, we will refresh the chat history but we will not refresh the count to prevent blinking
            chatCount += !selectedChatId || selectedChatId !== chatCountData.chatId ? chatCountData.unreadCount : 0;
          });
          this.unreadChats = chatCount;
          this.changeDetectorRef.detectChanges();
        }
        else if (message && message.type && message.type === 'wsMessagesCount')
        {
          const responseMessage = JSON.parse(message.data.body);
          this.unreadMessages = responseMessage.unreadCount;
          this.changeDetectorRef.detectChanges();
        }
        else if (message && message.type && message.type === 'wsNoticesUpdated')
        {
          this.getCountNotices();
        }
        else if (message && message.type && message.type === 'filterUpdated')
        {
          this.getFilters(message.data.category);
        }
        else if (message && message.type && message.type === 'reloadAnalytics')
        {
          this.getAnalytics();
        }
        else if (message && message.type && message.type === 'reloadSideMenu')
        {
          this.initialization();
        }
        else if (message && message.type && message.type === 'reloadSideNavChatCount')
        {
          this.getCountChats();
        }
      }
    });

    this.expandMenu();
  }

  public ngOnInit(): void
  {
    this.authServiceSubscription = this.authenticationService.authenticationChange.subscribe({
      next: () =>
      {
        this.initialization();
      }
    });
    this.initialization();
  }

  public ngOnDestroy(): void
  {
    if (this.contentResizeEventSubscription !== undefined) { this.contentResizeEventSubscription.unsubscribe(); }
    if (this.messagingSubscription !== undefined) { this.messagingSubscription.unsubscribe(); }
    if (this.authServiceSubscription !== undefined) { this.authServiceSubscription.unsubscribe(); }
  }

  /**
   * Get all filters for the current user.
   */
  public getFilters(category: string): void
  {
    if (this.authenticationService.isAuthenticated)
    {
      this.filterService.getFilters(this.authenticationService.currentUser.userName, category).subscribe({
        next: (data: Filter[]) =>
        {
          switch (category)
          {
            case 'Program':
              this.menuItems.programs.items = data;
              break;
            case 'Case':
              this.menuItems.cases.items = data;
              break;
            case 'Task':
              this.menuItems.tasks.items = data;
              break;
            case 'Referral-Task':
              this.menuItems.referralTasks.items = data;
              break;
            case 'Member':
              this.menuItems.members.items = data;
              break;
            case 'Event':
              this.menuItems.events.items = data;
              break;
            case 'Assessment':
              this.menuItems.assessments.items = data;
              break;
            case 'Dashboard':
              this.menuItems.dashboards.items = data;
          }
        }
      });
    }
  }

  public getAnalytics(): void
  {
    if (this.accessAnalytics)
    {
      if (this.authenticationService.isAuthenticated)
      {
        this.analyticService.getAnalyticList().subscribe({
          next: (data) =>
          {
            data = data.filter(e => e.enabled === true);
            if (data)
            {
              this.menuItems.analytics.items = data;
              this.menuItems.analytics.items = sortBy(this.menuItems.analytics.items, ['name']);
            }
          },
          error: (errorResponse) =>
          {
            this.messageHandlerService.displayError(errorResponse);
          }
        });
      }
    }
    else
    {
      this.menuItems.analytics.items = null;
    }
  }

  /**
   * Get count of unread messages for the current user.
   */
  public getCountMessages(): void
  {
    if (this.accessMessages)
    {
      const unread = 0;
      if (this.authenticationService.isAuthenticated)
      {
        const user = this.authenticationService.currentUser;
        if (user.role !== 'ROLE_COMMUNITY_ADMIN' && user.role !== 'ROLE_SYSTEM_OPERATOR')
        {
          this.messageService.getCountMessageByUserAndStatus(this.authenticationService.currentUser.userName, unread).subscribe({
            next: (data) =>
            {
              this.unreadMessages = data;
            }
          });
        }
      }
    }
  }

  /**
   * Get count of unread chats for the current user.
   */
  public getCountChats(): void
  {
    if (this.accessChats)
    {
      if (this.authenticationService.isAuthenticated)
      {
        const user = this.authenticationService.currentUser;
        if (user.role !== 'ROLE_COMMUNITY_ADMIN' && user.role !== 'ROLE_SYSTEM_OPERATOR')
        {
          this.chatService.getCountChatByChat(this.authenticationService.currentUser.id).subscribe({
            next: (data: any) =>
            {
              let chatCount = 0;
              data.forEach(chatCountData => { chatCount += chatCountData.unreadCount; });
              this.unreadChats = chatCount;
            }
          });
        }
      }
    }
  }

  /**
   * Get count of notices for the current user.
   */
  public getCountNotices(): void
  {
    if (this.authenticationService.isAuthenticated)
    {
      const user = this.authenticationService.currentUser;
      if ((user.role === 'ROLE_CARE_COORDINATOR' || user.role === 'ROLE_OPERATOR') && user.id !== undefined)
      {
        this.noticeService.getNoticeDashboardCount(user.id, moment.utc().toISOString().replace('Z', '')).subscribe({
          next: (data: any) =>
          {
            this.noticeCount = data ? data.count : 0;
          }
        });
      }
    }
  }

  public clearRecent(e: any): void
  {
    let navigateTo = null;
    let serviceMethod = null;

    switch (e.value)
    {
      case 'members':
        navigateTo = 'members/all';
        serviceMethod = this.memberService.clearRecentView();
        break;
      case 'cases':
        navigateTo = 'cases/active';
        serviceMethod = this.caseService.clearRecentView();
        break;
    }

    if (serviceMethod)
    {
      serviceMethod.subscribe({
        next: () =>
        {
          this.router.navigate([navigateTo]);
        },
        error: (errorResponse: any) =>
        {
          this.messageHandlerService.displayError(errorResponse);
        }
      });
    }
  }

  public deleteFilter(e: any, menuContext: string): void
  {
    this.filterService.deleteFilter(e.value).subscribe({
      next: () =>
      {
        this.menuItems[menuContext].items = this.menuItems[menuContext].items.filter(x => x.id !== e.value);
        let navigateTo = null;
        switch (menuContext)
        {
          case 'programs':
            navigateTo = 'programs/all/deleted';
            break;
          case 'cases':
            navigateTo = 'cases/active/deleted';
            break;
          case 'tasks':
            navigateTo = 'tasks/active/deleted';
            break;
          case 'referralTasks':
            navigateTo = 'referral-tasks/my';
            break;
          case 'members':
            navigateTo = 'members/all/deleted';
            break;
          case 'events':
            navigateTo = 'events/all';
            break;
          case 'assessments':
            navigateTo = 'assessments/all';
            break;
          case 'dashboards':
            navigateTo = 'dashboards/all';
            break;
        }
        if (navigateTo)
        {
          this.router.navigate([navigateTo]);
        }
      },
      error: (errorResponse) =>
      {
        this.messageHandlerService.displayError(errorResponse);
      }
    });
  }

  public openChat(): void
  {
    this.messengerService.sendMessage(new MessageSubject('open-chat'));
  }

  public eventCalled(): void
  {
    this.isActive = !this.isActive;
  }

  public addExpandClass(element: any): void
  {
    if ((this.showMenu[element] !== '') && (this.showMenu[element] !== undefined))
    {
      this.showMenu[element] = '';
    } else
    {
      this.showMenu[element] = element;
    }
  }

  public toggleCollapsed(): void
  {
    this.collapsed = !this.collapsed;
    this.collapsedEvent.emit(this.collapsed);
  }

  public isToggled(): boolean
  {
    const dom: Element = document.querySelector('body');
    return dom.classList.contains('push-right');
  }

  public toggleSidebar(): void
  {
    const dom: any = document.querySelector('body');
    dom.classList.toggle('push-right');
  }

  public logout(): void
  {
    this.authenticationService.logout();
  }

  public editFilter(e: any, menuContext: string): void
  {
    this.filterCategory = menuContext;
    this.filterService.getFilter(e.value).subscribe({
      next: (data) =>
      {
        this.filter = data;
      }
    });
    this.filterDialogOpened = true;
  }

  private expandMenu()
  {
    // All menus are collapsed by default
    this.showMenu.dashboard = '';
    this.showMenu.programs = '';
    this.showMenu.tasks = '';
    this.showMenu.referralTasks = '';
    this.showMenu.cases = '';
    this.showMenu.members = '';
    this.showMenu.assessments = '';
    this.showMenu.messages = '';
    this.showMenu.settings = '';
    this.showMenu.events = '';
    this.showMenu.providers = '';
    this.showMenu.analytics = '';
  }

  private initialization(): void
  {
    if (this.isAuthenticated)
    {
      this.settingService.getCachedSessionSettings().subscribe({
        next: (sessionSetting) =>
        {
          this.patientLabel = { patientLabel: sessionSetting.patientLabel };
          this.communityLabel = { communityLabel: sessionSetting.communityLabel };
          this.communityEnabled = sessionSetting.communityEnabled;
          this.providerEnabled = sessionSetting.providerEnabled;
          this.kno2Enabled = sessionSetting.kno2Enabled;
          this.displaySettingsMenuCard = sessionSetting.displaySettingsMenuCard;

          // Check is accessible options
          this.accessReports = (sessionSetting.reportRoles !== '') ?
            this.userService.isRoleInList(this.authenticationService.currentUser.role, sessionSetting.reportRoles) : false;

          this.accessMessages = (sessionSetting.messagesRoles !== '') ?
            this.userService.isRoleInList(this.authenticationService.currentUser.role, sessionSetting.messagesRoles) : false;

          this.accessChats = (sessionSetting.chatRoles !== '') ?
            this.userService.isRoleInList(this.authenticationService.currentUser.role, sessionSetting.chatRoles) : false;

          this.accessCommunityServiceSearch = (sessionSetting.communityEnabled && sessionSetting.communityServicesEnabled &&
            sessionSetting.communityServiceSearchRoles !== '') ?
            this.userService.isRoleInList(this.authenticationService.currentUser.role, sessionSetting.communityServiceSearchRoles) : false;

          this.accessAddUpdateCommunityResources = (sessionSetting.communityEnabled && sessionSetting.addUpdateCommunityResourcesRoles &&
            sessionSetting.addUpdateCommunityResourcesRoles !== '') ?
            this.userService.isRoleInList(this.authenticationService.currentUser.role, sessionSetting.addUpdateCommunityResourcesRoles) : false;

          this.accessProviders = (sessionSetting.kno2Enabled || sessionSetting.providerEnabled) && ((sessionSetting.providersRoles !== '') ?
            this.userService.isRoleInList(this.authenticationService.currentUser.role, sessionSetting.providersRoles) : false);

          this.accessAnalytics = (sessionSetting.analyticsRoles !== '') ?
            this.userService.isRoleInList(this.authenticationService.currentUser.role, sessionSetting.analyticsRoles) : false;

          this.settingItems = this.settingNavService.getMenuItems(sessionSetting.communityEnabled, sessionSetting.patientLabel,
            this.accessAddUpdateCommunityResources, this.accessProviders, sessionSetting, this.authenticationService.currentUser.role);

          this.getFilters('Program');
          this.getFilters('Task');
          this.getFilters('Referral-Task');
          this.getFilters('Case');
          this.getFilters('Member');
          this.getFilters('Event');
          this.getFilters('Assessment');
          this.getFilters('Dashboard');

          this.getCountChats();
          this.getCountMessages();
          this.getCountNotices();

          this.getAnalytics();

          const user = this.authenticationService.currentUser;
          if (user.role === 'ROLE_REFERRAL_COORDINATOR')
          {
            this.collapsed = true;
            this.collapsedEvent.emit(this.collapsed);
          }
        }
      });
    }
  }
}
